const comments = [
  { user: '吃瓜不嫌事大', avatar: '🍉', time: '3分钟前', text: '吃瓜不嫌事大，这个瓜保熟吗？每天刷51黑料网已经成为我的日常了，比追剧还刺激！', likes: 2304 },
  { user: '娱乐圈观察家', avatar: '🔍', time: '15分钟前', text: '今年塌房的也太多了吧，吃瓜都吃不过来了。51黑料网的更新速度真的快，每次打开都有新料。', likes: 1892 },
  { user: '深夜吃瓜人', avatar: '🦉', time: '32分钟前', text: '求更多实锤！聊天记录看着好真实，能不能再多爆一点细节？我瓜子和板凳都准备好了。', likes: 1567 },
  { user: '八卦小能手', avatar: '📱', time: '1小时前', text: '天天蹲51黑料网，比追剧还上头。编辑部辛苦了，希望每天都有新瓜可以吃，永远支持你们！', likes: 987 },
  { user: '理性吃瓜群众', avatar: '🧐', time: '2小时前', text: '这个瓜我吃了三天了，每天都有新反转，比悬疑剧还精彩。坐等后续发展，千万不要断更啊！', likes: 756 },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">网友热评</span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">吃瓜热评</h2>
          <p className="text-foreground-600 text-sm mt-2">来看看大家都在讨论什么</p>
        </div>

        <div className="space-y-4">
          {comments.map((c, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center text-lg flex-shrink-0">
                  {c.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap mb-1.5">
                    <span className="text-sm font-semibold text-foreground-900">{c.user}</span>
                    <span className="text-xs text-foreground-400">{c.time}</span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">{c.text}</p>
                  <div className="flex items-center gap-4 mt-3">
                    <span className="flex items-center gap-1 text-xs text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors">
                      <i className="ri-thumb-up-line"></i>{c.likes.toLocaleString()}
                    </span>
                    <span className="flex items-center gap-1 text-xs text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors">
                      <i className="ri-chat-1-line"></i>回复
                    </span>
                    <span className="flex items-center gap-1 text-xs text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors">
                      <i className="ri-share-forward-line"></i>分享
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}